import React, { useState, useEffect } from 'react';
import { Flex, Input, Modal, List, Checkbox, Radio, Button, Pagination, Form } from 'antd';
import { SwapOutlined, AppstoreAddOutlined } from '@ant-design/icons';
import getCurrentShop from '../shop/get-current-shop';

const style = {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // border: '1px solid #eee',
    // padding: 8,
};

export default (props) => {
    const { title = '', children, id, value, defaultValue, includeProxy = false, onChange = () => {}, multiple = false } = props;
    const [currentShop, setCurrentShop] = React.useState(null);
    const [currentShopId, setCurrentShopId] = React.useState(null);
    const [goods, setGoods] = React.useState([]);
    const modalRef = React.useRef(null);
    const [selectedGoods, setSelectedGoods] = React.useState([]);
    const [currentGoods, setCurrentGoods] = React.useState([]);
    const [goodsCount, setGoodsCount] = React.useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [form] = Form.useForm();
    
    React.useEffect(() => {
        const fetchShop = async () => {
            const shop = await getCurrentShop();
            setCurrentShop(shop);
            setCurrentShopId(shop?.shopId);
        };
        
        fetchShop();
    }, []);
    
    React.useEffect(() => {
        if (currentShopId) {
            getGoodsList();
        }
    }, [currentShopId]);
    
    const triggerChange = (changedValue) => {
        onChange?.(changedValue);
    };

    const getGoodsList = async (page = 1, pageSize = 10) => {
        let url = `/api/goods/my-list?status=1&shopId=${currentShopId}&page=${page}&pageSize=${pageSize}`;

        if(includeProxy) {
            url = `/api/goods/my-and-proxy-list?status=1&shopId=${currentShopId}&page=${page}&pageSize=${pageSize}`;
        }
        let response = await fetch(url);
        let result = await response.json();

        if(result && result.success) {
            setGoodsCount(result.data.count);
            setGoods(result.data.rows);
        }
    }

    const openGoodsSelector = () => {
        setIsOpen(true);
    }

    const onOk = () => {
        const values = form.getFieldsValue();
        let selectedGoods = [];

        if(multiple) {
            selectedGoods = goods.filter(item => values.selectedGoods.includes(item.goodsId));
            // selectedGoods = selectedGoods.map(({goodsId, title}) => ({goodsId, title}));
        }else {
            let temp = goods.find(item => item.goodsId === values.selectedGoods);
            // temp = {goodsId: temp.goodsId, title: temp.title};

            selectedGoods = temp ? [temp] : [];
        }

        setSelectedGoods(selectedGoods);
        setCurrentGoods(selectedGoods);
        triggerChange(selectedGoods);
        setIsOpen(false);
    }

    const handleGoodsDelete = (goodsId) => {
        const newShops = currentGoods.filter(item => item.goodsId !== goodsId);
        setSelectedGoods(newShops);
        setCurrentGoods(newShops);
        triggerChange(newShops);
    }

    return (
        <div>
            <Modal title='请选择商品' open={isOpen} onOk={onOk} centered onCancel={() => setIsOpen(false)} destroyOnClose={true}>
                <Form form={form} ref={modalRef} style={{ minHeight: '30vh', overflow: 'auto'}}>
                    {/* <Input.Search placeholder='搜索商品名' /> */}
                    <div style={{ padding: '15px 0' }}>
                        <Form.Item name='selectedGoods' rules={[{required: true, message: '至少选择一个商品'}]}>
                            {
                                multiple 
                                    ? <Checkbox.Group options={goods.map(item => ({ label: item.title, value: item.goodsId}))} style={style} /> 
                                    : <Radio.Group options={goods.map(item => ({ label: item.title, value: item.goodsId}))} style={style} />
                            }
                        </Form.Item>
                        
                        <Pagination align='end' simple={{ readOnly: true }} defaultCurrent={1} total={goodsCount} onChange={(page) => getGoodsList(+page)} />
                    </div>
                </Form>
            </Modal>
            {/* <Input type="hidden" value={value} onChange={onShopsChange} /> */}
            {
                currentGoods && <List bordered dataSource={currentGoods}  style={{margin: '0 0 10px 0'}} renderItem={
                    (item) => <List.Item actions={[<a onClick={() => handleGoodsDelete(item.goodsId)}>删除</a>]} key={item.goodsId}>{item.title}</List.Item>
                } />
            }
            <div><span onClick={openGoodsSelector}>{children ? children : <Button>选择商品</Button>}</span></div>
            
        </div>
    )
}